import React from 'react'
import { Breadcrumb } from 'antd'
import {Link} from 'react-router-dom'
import {withNamespaces} from 'react-i18next'

class CustomBreadcrumb extends React.Component {
  state={}
  componentDidMount() {

  }
  render() {
    const {match,t} = this.props
    const {params} = match
    const keys = Object.keys(params)
    if (Array.isArray(keys)&&keys.length>0) {
      if (params.key!=='home') {
        return (
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/">{t('key:home')}</Link>
            </Breadcrumb.Item>
            {
              keys.map((e,i)=>(
                <Breadcrumb.Item key={i}>
                  {
                    i<keys.length-1&&
                    <Link to={`/${params[e]}`}>{t(`key:${params[e]}`)}</Link>
                  }
                  {
                    i===keys.length-1&&
                    t(`key:${params[e]}`)
                  }
                </Breadcrumb.Item>
              ))
            }
          </Breadcrumb>
        )
      }
    }
    return (
      <Breadcrumb>
        <Breadcrumb.Item>{t('key:home')}</Breadcrumb.Item>
      </Breadcrumb>
    )
  }
}
export default withNamespaces('translations')(CustomBreadcrumb)
